import { Box, FlexLayout, H3, H4 } from '@deity/falcon-ui';
import { Button, Checkbox, Icon } from '@deity-io/portal-ui';
import { APOLLO_BASE_OPTIONS } from 'contracts/constants';
import { useState } from 'react';
import ReactJson from 'react-json-view';
import { useGetExpandedModelSchemaLazyQuery } from 'services/graphql/generated/hooks';

type StructureJSONViewProps = {
  model: {
    uuid: string;
    packageVersionUuid: string;
    schema: any;
    name: string;
    description: string;
  };
};

export const StructureJSONView: React.FC<StructureJSONViewProps> = ({ model }) => {
  const [state, setState] = useState<{ checked: boolean }>({ checked: false });
  const [expandSchema, { data: expandedSchema, loading, error: expandError }] =
    useGetExpandedModelSchemaLazyQuery(APOLLO_BASE_OPTIONS);

  const checkState = () => {
    const newChecked = !state.checked;
    if (!state.checked && !expandedSchema?.getExpandedModelSchema.schema) {
      expandSchema({
        variables: {
          packageVersionUuid: model.packageVersionUuid,
          uuid: model.uuid,
          schema: model.schema
        }
      });
    }
    setState({ ...state, checked: newChecked });
  };

  return (
    <Box p="xxl">
      <FlexLayout pb="xxl" justifyContent="space-between" alignItems="center">
        <Box key="info">
          <H4
            key="name"
            fontSize="xll"
            pt="xss"
            pb="xss"
            fontWeight="normal"
            mr="lg"
            border="regular"
            borderColor="transparent"
          >
            {model.name}
          </H4>
          <H3 key="description" color="secondary">
            {model.description || ''}
          </H3>
        </Box>
        <Box key="btn">
          <a
            download={`${model.name || 'schema'}.json`}
            href={`data:text/json;charset=utf-8,${encodeURIComponent(JSON.stringify(model.schema))}`}
            style={{ textDecoration: 'none' }}
          >
            <Button variant="outlined" sx={{ ml: 2 }} startIcon={<Icon icon="download" />}>
              Download JSON Schema
            </Button>
          </a>
        </Box>
      </FlexLayout>
      <H4 key="schema" fontWeight="bold" mb="xs">
        JSON Schema
      </H4>
      <Checkbox checked={state.checked} onChange={checkState} disabled={loading} />
      {loading ? 'Loading expanded schema' : 'Expand all links'}
      {expandError ? <H4 color="error">Error expanding links: {expandError.message}</H4> : null}
      <ReactJson
        key="json"
        src={
          state.checked && expandedSchema?.getExpandedModelSchema.schema
            ? expandedSchema?.getExpandedModelSchema.schema
            : model.schema
        }
        name={model.name}
        theme="ashes"
        collapseStringsAfterLength={18}
      />
    </Box>
  );
};
